module.exports = __webpack_public_path__ + "static/media/card-blue.583279e1.svg";